module.exports = __webpack_public_path__ + "files/1a0b83525500f58bb1ac0842c818c687.png";